{
  "user": {
    "donationCommentBox": {
      "description": "Include a message with your donation!"
    },
    "donationDonorSummary": {
      "editContactDetails": "Edit contact details",
      "taxReceipt": "Tax receipt",
      "addMailingAddress": "Add a mailing address for your receipt",
      "editMailingAddress": "Edit mailing address"
    },
    "donationDonorWall": {
      "title": "Recent donations",
      "empty": "Be the first to donate.",
      "anonymous": "Anonymous",
      "showAll": "Show all {count} donations"
    },
    "donationFlow": {
      "makeYourGift": "Make your gift",
      "tagsLegend": "Tags",
      "tagsHint": "Optional — pick any that are relevant to your donation.",
      "yourDetails": "Your details",
      "contactInformationLegend": "Contact information",
      "employer": "Employer",
      "searchEmployer": "Search for your employer",
      "businessMailingAddress": "Business mailing address",
      "mailingAddress": "Mailing address"
    },
    "donationFundraiserCard": {
      "raised": "raised",
      "ofGoal": "of {amount} goal",
      "beFirstToGive": "Be the first to give →"
    },
    "donationFundraiserDetail": {
      "organizedBy": "Organized by"
    },
    "donationFundraiserRail": {
      "heading": "Active fundraisers",
      "emptyHeading": "No active fundraisers right now"
    },
    "donationGiveCard": {
      "raisedOfGoal": "raised of {amount} goal",
      "raised": "raised",
      "donationsCount": "donations",
      "beFirstToDonate": "Be the first to donate",
      "donate": "Donate",
      "linkCopied": "Link copied",
      "taxDeductible": "Tax-deductible — instant receipt",
      "securePayment": "Secure payment"
    },
    "donationHero": {
      "title": "Donate to {name}",
      "securePayment": "Secure payment",
      "instantTaxReceipt": "Instant tax receipt",
      "subtitleWithReceipt": "Choose an amount to give. Your donation supports our work and is receipted right away.",
      "subtitle": "Choose an amount to give and support our work.",
      "donateAmount": "Donate {amount}",
      "donate": "Donate"
    },
    "donationSummary": {
      "givingAs": "Giving as",
      "receiptToRecipient": "receipt to {email}",
      "yourGift": "Your gift",
      "taxReceiptEmailed": "Tax receipt emailed",
      "toRecipient": "to {email}",
      "coverFees": "Cover the processing fees",
      "feeExplanation": "Processing fees are charged by payment companies like Visa and PayPal. Cover the fee so {orgName} receives 100% of your donation.",
      "addToCart": "Add to cart"
    },
    "donationTagSelect": {
      "tagRequired": "A tag selection must be made."
    },
    "donationType": {
      "label": "Select your donation type *",
      "invalidFeedback": "Please select a donation type.",
      "personal": "Personal",
      "corporate": "Corporate"
    },
    "donationsCreate": {
      "pageTitle": "Donate",
      "donateToFundraiser": "Donate to {title}",
      "donateToOrg": "Donate to {name}"
    },
    "donationsIndex": {
      "emptyHeadingGlobal": "One way to give, no fundraisers needed",
      "emptyHeadingDefault": "No active fundraisers right now",
      "emptyMessageGlobal": "Your donation goes straight to {name}, where it's needed most. Choose an amount above to get started.",
      "emptyMessageDefault": "Check back soon — new fundraisers will appear here.",
      "pageTitle": "Donations"
    },
    "myDonationsIndex": {
      "heading": "My Donations",
      "amountColumn": "Amount",
      "dateColumn": "Date",
      "pageTitle": "My Donations"
    }
  },
  "manager": {
    "formDonationAmounts": {
      "itemLabel": "Donation amount",
      "addLabel": "Add donation amount",
      "emptyMessage": "No donation amounts configured. The default checkout donation amounts will be shown.",
      "invalidFeedback": "Each amount must be at least $1.00."
    },
    "fundraiserViewDonors": {
      "donorsFor": "Donors for",
      "name": "Name",
      "email": "Email",
      "amountDonated": "Amount Donated"
    },
    "donationInformationForm": {
      "taxReceiptStartingNumberLabel": "Tax Receipt Starting Number *",
      "taxReceiptStartingNumberDescription": "The number your first tax receipt will be issued at.",
      "digitalSignatureLabel": "Digital Signature *",
      "digitalSignatureDescription": "Signed by your organization and shown on every tax receipt.",
      "currentSignature": "Current signature",
      "currentSignatureAlt": "Current digital signature",
      "drawToReplace": "Draw below to replace it.",
      "drawSignature": "Draw your signature below.",
      "clear": "Clear",
      "einLabel": "EIN *",
      "charityNumberLabel": "Charity Number *",
      "einPlaceholder": "Ex: 12-3456789",
      "charityNumberPlaceholder": "Ex: 123456789-RR-1234"
    },
    "donationSettings": {
      "heading": "Donation Settings",
      "taxReceipts": "Tax Receipts",
      "taxReceiptsDescription": "Details shown on tax receipts issued to your donors.",
      "taxReceiptUnavailable": "Tax receipt configuration is only available for tenants in the United States (USD) and Canada (CAD). Your organization's currency is {currency}.",
      "checkoutAmounts": "Checkout Donation Amounts",
      "checkoutAmountsDescription": "Suggested amounts donors see at checkout. Leave empty to use the default amounts.",
      "loadError": "Unable to load donation settings",
      "saved": "Donation settings saved",
      "pageTitle": "Donation Settings"
    },
    "donationsCreate": {
      "intro": "Record cash, cheque, or other offline donations. The funds-received date drives reporting and transaction filtering; today’s record timestamp is kept untouched.",
      "donationSection": "Donation",
      "fundsReceivedDateLabel": "Funds received date *",
      "fundsReceivedDateInvalid": "Please enter the date the funds were received.",
      "dateHint": "Used for donation reporting and the transactions list.",
      "donationTypeSection": "Donation type",
      "businessDonor": "Business donor",
      "donor": "Donor",
      "businessMailingAddress": "Business mailing address",
      "mailingAddress": "Mailing address",
      "paymentSection": "Payment",
      "allocationSection": "Allocation",
      "sendTaxReceipt": "Send the donor a tax receipt",
      "ledgerEntry": "Ledger entry",
      "from": "from",
      "received": "received",
      "saveDonation": "Save donation",
      "pageTitle": "Create Donation",
      "typeCorporate": "corporate",
      "typePersonal": "personal",
      "datePending": "date pending",
      "chequeNumber": "cheque #{number}",
      "entityDonation": "Donation"
    },
    "donationsIndex": {
      "title": "Donations",
      "pageTitle": "Donations",
      "tagsFilter": "Tags",
      "fundraisersFilter": "Fundraisers"
    },
    "donationsShow": {
      "title": "View Donation",
      "downloadReceipt": "Download Receipt",
      "generatingReceipt": "Generating Receipt...",
      "resendTaxReceipt": "Resend Tax Receipt",
      "generateAndSendTaxReceipt": "Generate & Send Tax Receipt",
      "moreActions": "More Actions",
      "generateTaxReceiptOnly": "Generate Tax Receipt Only",
      "deleteDonation": "Delete Donation",
      "donorInformation": "DONOR INFORMATION",
      "donationInformation": "DONATION INFORMATION",
      "activity": "ACTIVITY",
      "generateOnlyConfirm": "Are you sure you would like to generate a tax receipt without sending it via email?",
      "pageTitle": "View Donation",
      "entityDonation": "Donation",
      "taxReceiptGeneratingAndSending": "Tax receipt is being generated and sent.",
      "taxReceiptGenerating": "Tax receipt is being generated.",
      "deleted": "Donation deleted."
    },
    "fundraiserIndex": {
      "title": "Fundraisers",
      "pageTitle": "Fundraisers"
    },
    "tagCreate": {
      "tagNameLabel": "Tag Name *",
      "tagNamePlaceholder": "Enter tag name",
      "editTitle": "Edit Donation Tag",
      "createTitle": "Create Donation Tag",
      "entityTag": "Tag"
    },
    "tagIndex": {
      "title": "Donation Tags",
      "pageTitle": "Donation Tags"
    },
    "fundraiserCreateContainer": {
      "fundraiserDetails": "Fundraiser details",
      "titleLabel": "Title *",
      "titlePlaceholder": "Example: Community Gardens",
      "summaryLabel": "Summary *",
      "summaryPlaceholder": "A short summary describing this fundraiser.",
      "descriptionLabel": "Description *",
      "goalLabel": "Donation Goal",
      "statusLabel": "Status",
      "additionalSettings": "Additional settings",
      "tagsLabel": "Associated tags",
      "tagsDescription": "Any donation tagged with these tags will be associated with this fundraiser and its amount will be included in the fundraiser's total.",
      "tagsPlaceholder": "Search for a tag",
      "enableTaxReceipting": "Enable tax receipting"
    }
  },
  "guest": {
    "donateIndex": {
      "emptyHeadingGlobal": "One way to give, no fundraisers needed",
      "emptyHeadingDefault": "No active fundraisers right now",
      "emptyMessageGlobal": "Your donation goes straight to {name}, where it's needed most. Choose an amount above to get started.",
      "emptyMessageDefault": "Check back soon — new fundraisers will appear here.",
      "pageTitle": "Donations"
    },
    "donationCreate": {
      "pageTitle": "Donate",
      "donateToFundraiser": "Donate to {title}",
      "donateToOrg": "Donate to {name}"
    }
  }
}
